import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import {
    IBuyboxAddToCartViewProps
} from '@msdyn365-commerce-modules/buybox';
import { IBuyboxViewPropsExtended } from '../types';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { mfrmgetBuyboxAddToCart } from './addtocart';

export const BuyboxAddToCart = (props:{
    addToCart: IBuyboxAddToCartViewProps,
    buyboxProps: IBuyboxViewPropsExtended,
    variantOutOfStock: boolean,
    itemOutOfMarket: boolean,
    outOfStockSmallParcelState: boolean,
    adjustableItem: SimpleProduct | undefined,
    pillow: SimpleProduct | undefined,
    protector: SimpleProduct | undefined
}): JSX.Element => {
    const {addToCart, buyboxProps, variantOutOfStock, itemOutOfMarket, outOfStockSmallParcelState, adjustableItem, pillow, protector} = props;
    const { ContainerProps } = addToCart;
    const mfrmDefaultMinimumKeyInPrice = 10;
    const mfrmDefaultMaximumKeyInPrice = 100;
    // tslint:disable-next-line:max-line-length
    const mfrmAddToCart = mfrmgetBuyboxAddToCart(
        buyboxProps,
        mfrmDefaultMinimumKeyInPrice,
        mfrmDefaultMaximumKeyInPrice,
        variantOutOfStock,
        itemOutOfMarket,
        outOfStockSmallParcelState,
        adjustableItem,
        pillow,
        protector
    ); // mfrmgetBuyboxAddToCart(props, props.state, props.callbacks, mfrmDefaultMinimumKeyInPrice, mfrmDefaultMaximumKeyInPrice);

    return (
        <Node {...ContainerProps}>
            {mfrmAddToCart && mfrmAddToCart.errorBlock}
            {mfrmAddToCart && mfrmAddToCart.button}
        </Node>
    );
};
